import Dashboard from '~/components/Dashboard/Dashboard';
import Heading from '~/components/Shared/Heading/Heading';
import Page from '~/components/Shared/Layout/Page/Page';
import DashBoardPageActions from './DashBoardPageActions/DashBoardPageActions';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { Content, List, Root, Trigger } from '@radix-ui/react-tabs';
import styles from './DashboardPage.module.scss';
import cn from 'classnames';
import EmployeesDashboard from '~/components/Dashboard/EmployeesDashboard/EmployeesDashboard';

export interface IIdsProps {
  assetsIds: number[];
  accommodationIds: number[];
  organizationIds: number[];
}

const ACTIVE_TABS = {
  GENERAL: 'general',
  EMPLOYEES: 'employees',
};

const DashboardPage = () => {
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');
  const [assetsIds, setAssetsIds] = useState<[] | number[]>([]);
  const [accommodationIds, setAccommodationIds] = useState<[] | number[]>([]);
  const [organizationIds, setOrganizationIds] = useState<[] | number[]>([]);
  const { t } = useTranslation();
  const [activeTab, setActiveTAb] = useState(ACTIVE_TABS.GENERAL);

  useEffect(() => {
    setStartDate(
      localStorage.getItem('startDate') ||
        dayjs().subtract(7, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss')
    );
    setEndDate(
      localStorage.getItem('endDate') ||
        dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')
    );
  }, []);

  const handleSetIds = (data: IIdsProps) => {
    setAssetsIds(data.assetsIds);
    setAccommodationIds(data.accommodationIds);
    setOrganizationIds(data.organizationIds);
  };

  return (
    <Page
      heading={
        <Heading
          text={t('Dashboard')}
          actions={
            <DashBoardPageActions
              startDate={startDate}
              endDate={endDate}
              setStartDate={setStartDate}
              setEndDate={setEndDate}
              onClick={(value: IIdsProps) => handleSetIds(value)}
            />
          }
        />
      }
    >
      <Root
        value={activeTab}
        onValueChange={value => setActiveTAb(value)}
        className={styles.roots}
      >
        <List className={styles.rootsList}>
          <Trigger
            value={ACTIVE_TABS.GENERAL}
            className={cn(styles.rootsTrigger, {
              [styles.activeTrigger]: activeTab === ACTIVE_TABS.GENERAL,
            })}
          >
            {t('general')}
          </Trigger>
          <Trigger
            value={ACTIVE_TABS.EMPLOYEES}
            className={cn(styles.rootsTrigger, {
              [styles.activeTrigger]: activeTab === ACTIVE_TABS.EMPLOYEES,
            })}
          >
            {t('employees')}
          </Trigger>
        </List>

        <Content value={ACTIVE_TABS.GENERAL}>
          <Dashboard
            startDate={startDate}
            endDate={endDate}
            assetsIds={assetsIds}
            accommodationIds={accommodationIds}
            organisationIds={organizationIds}
          />
        </Content>
        <Content value={ACTIVE_TABS.EMPLOYEES}>
          <EmployeesDashboard
            startDate={startDate}
            endDate={endDate}
            assetsIds={assetsIds}
            accommodationIds={accommodationIds}
            organizationIds={organizationIds}
          />
        </Content>
      </Root>
    </Page>
  );
};

export default DashboardPage;
